import {
  PaymentType,
  type Dimension,
  type PriceTypes,
} from '../../../modules/privateOffer/types'

export enum AdditionalCPPODataKeys {
  'DISCOUNT_TYPE' = 'Discount Type',
  'DISCOUNT_PERCENTAGE' = 'Discount Percentage',
  'CONTRACT_DURATION_TYPE' = 'Contract Duration Type',
  'CONTRACT_DURATION_IN_MONTHS_FOR_END_CUSTOMER' = 'Contract Duration In Months For End Customer',
  'RESELLER_LICENSE_AGREEMENT_TYPE' = 'Reseller License Agreement Type',
  'RESELLER_LICENSE_AGREEMENT_FILES' = 'Reseller License Agreement Files',
  'BUYER_AWS_ACCOUNT_ID' = 'Buyer AWS account ID',
  'AGREEMENT_DURATION_TYPE' = 'Agreement Duration Type',
  'AGREEMENT_EXPIRATION_DATE' = 'Agreement Expiration Date',
}

export const getDimensionPrice = (isResale: boolean, dimension: Dimension) => {
  return isResale
    ? ({
        ...(dimension?.prices as PriceTypes),
        price: dimension?.price,
      } as PriceTypes)
    : ({
        price: dimension?.price ?? null,
      } as PriceTypes)
}

export const renewalChannelMapping = {
  EXTERNAL: 'Existing customer moving to AWS Marketplace',
  AWS_MARKETPLACE: 'Existing customer on AWS Marketplace',
  NEW: 'New - deals that are net-new bussiness',
  MIGRATION:
    'Migration - new Google cloud workload (deals moves from on-prem or other hyperscalers to Google cloud)',
  CHANNEL_SHIFT:
    'Channel shift - deals moves from partner paper to marketplace (workload already on Google cloud)',
  NATIVE_RENEWAL: 'Native renewal - deals that are renewing on the marketplace',
  '-': '-',
}

export const getValidDurationDetail = (
  paymentType?: PaymentType,
  isUsage?: boolean
) => {
  if (paymentType === PaymentType.MONTHLY || isUsage)
    return 'Contract duration in months'
  else if (paymentType === PaymentType.QUARTERLY)
    return 'Contract duration in quarters'
  else if (paymentType === PaymentType.ANNUALLY)
    return 'Contract duration in years'
  else return ''
}
export const getdurationDetailFlatFee = (
  paymentType?: PaymentType,
  isUsage?: boolean
) => {
  if (paymentType === PaymentType.MONTHLY || isUsage) return 'Monthly flat fee'
  else if (paymentType === PaymentType.QUARTERLY) return 'Quarterly flat fee'
  else if (paymentType === PaymentType.ANNUALLY) return 'Annual flat fee'
  else return ''
}
export const getTcvEstimateDetail = (
  serviceLength: number,
  flatFeePrice: number
) => {
  if (serviceLength >= 0 && flatFeePrice >= 0)
    return (serviceLength * flatFeePrice).toFixed(2)
  else return 0
}

export const flatFeeText = (paymentType?: PaymentType) => {
  if (paymentType === PaymentType.MONTHLY) return 'Monthly'
  else if (paymentType === PaymentType.QUARTERLY) return 'Quarterly'
  else if (paymentType === PaymentType.ANNUALLY) return 'Annualy'
  else return 'Custom'
}

export const priceMapping = {
  price1m: '1 Month',
  price12m: '12 Month',
  price24m: '24 Month',
  price36m: '36 Month',
}
